<template>
    <div class="tl-section">
        <div class="tl-row">
            <div class="tl-columnheader">
                <h2 class="tl-tit">원하는 스타일 <span class="color-red">*</span></h2>
            </div>
            <div class="tl-cell">
                <input class="input" type="file" accept="image/*" @change="uploadPhoto" />
                <img :src="createObjectURL(image)" style="margin-left:1rem;max-height: 10rem;" />
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            image: "",
        };
    },
    methods: {
        uploadPhoto(event) {
            try {
                const [target] = event.target.files;
                if (target.size > 1024 * 1024 * 10) throw new Error("파일은 10MB를 초과할 수 없습니다.");

                this.image = event.target.files[0];
                this.$forceUpdate();
                this.$emit("set-input", { image: this.image });
            } catch (error) {
                console.log(error);
                alert(error.response ? error.response.data.message : error.message);
                event.target.value = "";
            }
        },
        createObjectURL(file) {
            return file ? URL.createObjectURL(file) : null;
        },
    },
};
</script>
